import React, { useEffect, useState, useContext } from 'react';
import { Row, Col, Button  } from 'react-bootstrap';
import { msalConfig, loginRequest } from "../../../authConfig";


const UnauthenticatedScreen = (props) => {
    const [bgColor, setBgColor] = useState('#0033A0');
    const [colorBorder, setColorBorder] = useState('#0033A0');

    const { text ,msal}=props



    const handleLogin = () => {
        msal.loginPopup(loginRequest)
            .then((loginResponse) => {
                localStorage.setItem('isLoggedIn', 'true');
            })
            .catch((error) => console.log(error))
    }

    return (
        <div style={{ 
            height: '100%', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            padding: '15px'
        }}>
            <div style={{ 
                width: '100%',
                backgroundColor: 'white',
                borderRadius: '16px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                padding: '20px',
                color: 'black',
                textAlign: 'center'
            }}>
                <div className="mx-auto">
                    <img className="d-block mx-auto mb-4" src="https://avviteo-dev.afpcapital.cl/asistente_th_logo.png" alt="" width="80" height="80" />
                    <p className="lead mb-4" style={{ fontSize:"19px", textAlign: "left" , paddingBottom:"5px"}}>Bienvenido al asistente virtual Viteo, para ingresar por favor inicia sesión con tu usuario de red</p>
                    <p>{text}</p>
                    <Button className="secondary" onClick={handleLogin} style={{fontWeight: 'normal', fontSize: "20px", width:"100%", maxWidth: "300px", color: 'white', backgroundColor: bgColor , borderColor: colorBorder     }} onMouseLeave={() => {
                        setBgColor("#0033A0")
                        setColorBorder("#0033A0")
                    }}
                    onMouseEnter={() => {
                        setBgColor("#00236E")
                        setColorBorder("#000000")
                    }}>
                        Ingresar
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default UnauthenticatedScreen;